<script>
import ExpandingControlBox from "@/components/ExpandingControlBox";
import OpenModalHotkeysButton from "@/components/OpenModalHotkeysButton";
import OptionsButton from "@/components/OptionsButton";
import PrimaryToggleButton from "@/components/PrimaryToggleButton";
import SelectNotationDropdown from "@/components/tabs/options-visual/SelectNotationDropdown";
import SelectThemeDropdown from "@/components/tabs/options-visual/SelectThemeDropdown";
import SelectSidebarDropdown from "@/components/tabs/options-visual/SelectSidebarDropdown";
import UpdateRateSlider from "./UpdateRateSlider";

export default {
  name: "OptionsVisualTab",
  components: {
    UpdateRateSlider,
    PrimaryToggleButton,
    ExpandingControlBox,
    OptionsButton,
    OpenModalHotkeysButton,
    SelectThemeDropdown,
    SelectNotationDropdown,
    SelectSidebarDropdown
  },
  data() {
    return {
      theme: "",
      notation: "",
      sidebarResource: "",
      headerTextColored: true,
    };
  },
  computed: {
    sidebarDB: () => GameDatabase.sidebarResources,
    themeLabel() {
      return `Тема: ${Themes.find(this.theme).displayName()}`;
    },
    notationLabel() {
      return `Запись: ${this.notationName()}`;
    },
    sidebarLabel() {
      return `Боковая панель: ${this.sidebarResource}`;
    },
    UILabel() {
      return `Интерфейс: ${this.$viewModel.newUI ? "Современный" : "Классический"}`;
    }
  },
  watch: {
    headerTextColored(newValue) {
      player.options.headerTextColored = newValue;
    },
  },
  methods: {
    update() {
      const options = player.options;
      this.theme = Theme.currentName();
      this.notation = options.notation;
      this.sidebarResource = player.options.sidebarResourceID === 0
        ? "Последний Ресурс"
        : this.sidebarDB.find(e => e.id === player.options.sidebarResourceID).optionName;
      this.headerTextColored = options.headerTextColored;
    },
    notationName() {
      let nName = this.notation;

      nName = nName.replace("Scientific", "Научная");
      nName = nName.replace("Engineering", "Инженерная");
      nName = nName.replace("Letters", "Буквенная");
      nName = nName.replace("Standard", "Стандартная");
      nName = nName.replace("Emoji", "Эмодзи");
      nName = nName.replace("Mixed scientific", "Смешанная научная");
      nName = nName.replace("Mixed engineering", "Смешанная инженерная");
      nName = nName.replace("Logarithm", "Логарифмическая");
      nName = nName.replace("Brackets", "Скобки");
      nName = nName.replace("Infinity", "Бесконечность");
      nName = nName.replace("Roman", "Римская");
      nName = nName.replace("Dots", "Точки");
      nName = nName.replace("Zalgo", "Залго");
      nName = nName.replace("Hex", "Шестнадцетеричная");
      nName = nName.replace("Imperial", "Имперская");
      nName = nName.replace("Clock", "Часы");
      nName = nName.replace("Prime", "Прайм");
      nName = nName.replace("Bar", "Полоса");
      nName = nName.replace("Shi", "Ши");
      nName = nName.replace("Blind", "Слепая");
      nName = nName.replace("Blobs", "Блобы");
      nName = nName.replace("ALL", "ВСЕ");

      return nName;
    },
  }
};
</script>

<template>
  <div class="l-options-tab">
    <div class="l-options-grid">
      <div class="l-options-grid__row">
        <OptionsButton
          class="o-primary-btn--option_font-large"
          onclick="GameOptions.toggleUI()"
        >
          {{ UILabel }}
        </OptionsButton>
        <UpdateRateSlider />
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.newsOptions.show();"
        >
          Открыть Настройки Новостей
        </OptionsButton>
      </div>
      <div class="l-options-grid__row">
        <ExpandingControlBox
          class="l-options-grid__button c-options-grid__notations"
          button-class="o-primary-btn o-primary-btn--option l-options-grid__notations-header"
          :label="themeLabel"
        >
          <template #dropdown>
            <SelectThemeDropdown />
          </template>
        </ExpandingControlBox>
        <ExpandingControlBox
          class="l-options-grid__button c-options-grid__notations"
          button-class="o-primary-btn o-primary-btn--option l-options-grid__notations-header"
          :label="notationLabel"
        >
          <template #dropdown>
            <SelectNotationDropdown />
          </template>
        </ExpandingControlBox>
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.notation.show();"
        >
          Открыть Опции Экспоненциальной Записи
        </OptionsButton>
      </div>
      <div class="l-options-grid__row">
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.animationOptions.show();"
        >
          Открыть Настройки Анимаций
        </OptionsButton>
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.infoDisplayOptions.show()"
        >
          Открыть Настройки Отображения Информации
        </OptionsButton>
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.awayProgressOptions.show()"
        >
          Открыть Настройки Офлайн Прогресса
        </OptionsButton>
      </div>
      <div class="l-options-grid__row">
        <OptionsButton
          class="o-primary-btn--option"
          onclick="Modal.hiddenTabs.show()"
        >
          Настроить Видимые Вкладки
        </OptionsButton>
        <PrimaryToggleButton
          v-model="headerTextColored"
          class="o-primary-btn--option l-options-grid__button"
          label="Относительный цвет заработка престижа:"
        />
        <ExpandingControlBox
          v-if="$viewModel.newUI"
          class="l-options-grid__button c-options-grid__notations"
          button-class="o-primary-btn o-primary-btn--option l-options-grid__notations-header"
          :label="sidebarLabel"
        >
          <template #dropdown>
            <SelectSidebarDropdown />
          </template>
        </ExpandingControlBox>
      </div>
      <OpenModalHotkeysButton />
    </div>
  </div>
</template>
